<template>
  <div class="subprogram-tryout-input">
    <el-form
      :label-position="labelPosition"
      :label-width="labelWidthForm"
      :model="model"
      :rules="rules"
      class="form"
      ref="form"
      v-if="model"
    >
      <el-row :gutter="10">
        <!-- Payment -->
        <el-col :lg="18" :md="18" :sm="24">
          <el-form-item class="el-form-item--radio" :prop="fields.exist.name" required>
            <span v-text="fields.exist.label" />
            <el-radio-group v-model="model[fields.exist.name]">
              <el-radio :label="true">
                <app-i18n code="common.yes" />
              </el-radio>
              <el-radio :label="false">
                <app-i18n code="common.no" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <!-- Dates -->
        <app-date-range
          v-if="model[fields.exist.name]"
          :startLabel="fields.startDate.label"
          :endLabel="fields.endDate.label"
          :required="true"
          :startDate.sync="model[fields.startDate.name]"
          :endDate.sync="model[fields.endDate.name]"
          :startPlaceholder="i18n('common.date.formatInput').toLowerCase()"
          :endPlaceholder="i18n('common.date.formatInput').toLowerCase()"
          :startFormat="i18n('common.date.formatInput')"
          :endFormat="i18n('common.date.formatInput')"
          ref="dateRangeTryout"
        />
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { FormSchema } from '@shared/form/form-schema';
import { SubprogramTryoutModel } from '@modules/subprogram/subprogram-tryout-model';
import { i18n } from '@shared/i18n';
import 'fix-date';

const { fields } = SubprogramTryoutModel;
const formSchema = new FormSchema([
  fields.exist,
  fields.startDate,
  fields.endDate,
]);

export default {
  name: 'subprogram-tryout-input',

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      initialModel: null,
    };
  },

  props: {
    tryout: Object,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
    }),

    fields() {
      return fields;
    },
    

  },

  async created() {
    this.initialModel = Object.assign({}, this.tryout);
    this.model = formSchema.initialValues(this.tryout);
  },

  methods: {
    doReset() {
      this.model = formSchema.initialValues(
        this.initialModel,
      );
    },
    
    i18n(code) {
      return i18n(code);
    },
  },

  watch: {
    model: {
      deep: true,
      handler() {
        this.$emit(
          'update:tryout',
          formSchema.cast(this.model),
        );
      },
    },
  },
};
</script>

<style scoped>
.subprogram-tryout-input .el-form {
  padding: 0 0 30px;
}
</style>